var indentation_default = {
  "indentZero": "SeNKp",
  "indentOne": "PETIt",
  "indentTwo": "YCBTa",
  "indentThree": "I3eS1",
  "indentFour": "uNuLH",
  "indentFive": "Lht0y",
  "indentSix": "AxsMT"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
